// @ts-nocheck
import CDN from '@/constants/cdn.json'

export function returnFiletypeIcon(type?: string | null) {
    switch (type) {
        // Code and source files
        case 'js': case 'ts': case 'html': case 'css': case 'json': case 'xml': case 'sql':
            return CDN.images["item-types"].code;
        
        // Microsoft Word files
        case 'doc': case 'docx':
            return CDN.images["item-types"].docx;

        // Microsoft OneNote files
        case 'onetoc': case 'onepkg': case 'onetoc2': case 'onetmp': case 'one':
            return CDN.images["item-types"].onetoc;
        
        // Microsoft PowerPoint files
        case 'ppt': case 'pptx': case 'pptm': case 'potx': case 'ppsx': case 'potm':
            return CDN.images["item-types"].pptx;

        // Text files
        case 'txt': case 'md': case 'rtf': case 'log':
            return CDN.images["item-types"].txt;

        // Microsoft Excel files
        case 'xls': case 'xlsx': case 'xlsm': case 'xltx': case 'xltm':
            return CDN.images["item-types"].xlsx;
        
        // Compressed files (zip, rar, etc.)
        case 'zip': case 'rar': case '7z': case 'tar': case 'gz': case 'bz2':
            return CDN.images["item-types"].zip;

        // PDF files
        case 'pdf':
            return CDN.images["item-types"].pdf;
        
        // Image files
        case 'jpeg': case 'jpg': case 'png': case 'gif': case 'bmp': case 'tiff': case 'svg': case 'jfif':
            return CDN.images["item-types"].photo;

        // Audio files
        case 'mp3': case 'wav': case 'aac': case 'flac': case 'ogg': case 'm4a':
            return CDN.images["item-types"].audio;

        // Video files
        case 'mp4': case 'mkv': case 'avi': case 'mov': case 'wmv': case 'flv':
            return CDN.images["item-types"].video;

        // Generic fallback for unknown or other file types
        default:
            return CDN.images["item-types"].genericfile;
    }
}

export function getFiletypeExtention(filename?: string | null) {
    if(!filename) return '';
    return filename.toLowerCase().split('.').pop()
}